import { render, staticRenderFns } from "./campaigns-merge.vue?vue&type=template&id=78bc570b&scoped=true"
import script from "./campaigns-merge.vue?vue&type=script&lang=js"
export * from "./campaigns-merge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bc570b",
  null
  
)

export default component.exports